module.exports = __webpack_public_path__ + "img/various-icon-b.7be5007b.png";